import ReleaseForm from '@/components/Registry/BillToPay/ReleaseForm';
import { useInstallmentCreate } from '@/core/domain/financial/AccountPayable/AccountPayable.hooks';
import {
  AccountPayableReleaseFormValues,
  AccountPayableReleaseRequest,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { DateTimeFormat } from '@/utils/moment';
import { Form, Modal, ModalProps } from 'antd';
import { Moment } from 'moment';
import { useEffect } from 'react';

interface InitialData {
  description?: string;
  value?: number;
  payDate?: Moment;
  bankAccountId?: number;
}

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  initialData?: InitialData;
}

export default function AccountPayableCreateModal({
  initialData,
  ...props
}: Props) {
  const [form] = Form.useForm<AccountPayableReleaseFormValues>();

  const accountPayableCreate = useInstallmentCreate();

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        description: initialData.description,
        installmentValue: initialData.value,
        dueDate: initialData.payDate,
        bankAccountId: initialData.bankAccountId,
      });
    }
  }, [initialData]);

  function handleCancel() {
    props.onCancel();
    form.resetFields();
  }

  async function handleSubmit() {
    const values = await form.validateFields();

    const obj: AccountPayableReleaseRequest = {
      ...values,
      emissionDate: values.emissionDate.format(DateTimeFormat),
      dueDate: !!values.dueDate
        ? values.dueDate.format(DateTimeFormat)
        : undefined,
      installmentNumber: 1,
      description: values.description ?? '',
    };

    await accountPayableCreate.mutateAsync(obj);

    handleCancel();
  }

  return (
    <Modal
      {...props}
      width={1300}
      okText="Criar"
      title="Criação de Contas a Pagar"
      onOk={handleSubmit}
      confirmLoading={accountPayableCreate.isLoading}
    >
      <ReleaseForm form={form} />
    </Modal>
  );
}
